<template>
  <a-modal name="respond-application">
    <div
      class="respond-application"
      @click.self="closeModal"
    >
      <svg
        class="respond-application-background"
        width="1597"
        height="431"
        viewBox="0 0 1597 431"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="-3" width="1600" height="431" fill="#6367A7"/>
      </svg>
      <form class="respond-application-modal">
<!--        <span-->
<!--          @click="closeModal"-->
<!--          class="respond-application-modal__close"-->
<!--        >-->
<!--          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <rect y="14.1426" width="20" height="2" transform="rotate(-45 0 14.1426)" fill="#68737D"/>-->
<!--            <rect x="14.1484" y="15.5566" width="20" height="2" transform="rotate(-135 14.1484 15.5566)" fill="#68737D"/>-->
<!--          </svg>-->
<!--        </span>-->
        <h2 class="respond-application-modal__title">
         {{subResponseApplication.messages.title}}
        </h2>
        <p class="respond-application-modal__text">
          {{subResponseApplication.messages.subTitle}}
        </p>
        <div class="row">
          <div class="col sm-12" :class="'d'+field.greedLang" v-for="field in fields">
            <AInput
                v-if="field.type=='text'||field.type=='textarea'"
                v-model="field.value"
                :type="field.type"
                :error="field.error"
                :hint="field.maxLength?textLimitHint(field.value,field.maxLength):field.hint"
                :label="field.title"
            />
            <a-checkbox
                v-else-if="field.type=='checkbox'"
                :name="field.name"
                :disabled="field.disabled"
                :label="field.title"
                :error="field.error"
                :checked="field.disabled||field.value?true:false"
                v-model="field.value"
            />
          </div>
        </div>
        <div class="respond-application-buttons">
          <ABtn
            @click.prevent="handlerAdd"
            :label="subResponseApplication.messages.sendBtnTitle"
            bg="#00A59E"
          />
          <ABtn
            @click="closeModal"
            class="respond-application-reset"
            :label="subResponseApplication.messages.closeBtnTitle"
            bg="transparent"
            color="#00A59E"
            type="reset"
          />
        </div>
      </form>
    </div>
  </a-modal>
</template>

<script>
import { reactive, ref } from 'vue';
import {useResponseApplication} from "~/composables/useResponseApplication";
import {useAModal, AModal, AInput, ABtn, ACheckbox, useAProgressBar} from "../../ui";
import { validateFormItem } from "~/libs/Validators";
import {send} from "../../../services/api";
// import UserFiles from "../cards/UserFiles";

export default {
  name: 'RespondApplication',
  props: ['result'],
  components: {
    AModal,
    ACheckbox,
    AInput,
    ABtn,
  },
  setup() {
    const modal = useAModal();
    const {subResponseApplication} = useResponseApplication();
    let applicationText = ref('');

    let fields = ref(JSON.parse(JSON.stringify(subResponseApplication.value.fields)));
    const closeModal = () => {
      modal.hide();
    }
    const progress = useAProgressBar();
    /**
     * Подсказка сколько символов осталось ввести если есть ограничение
     * @todo make it global
     * @param type String - ключ из v-model поля
     * @param limit Number - ограничение по символам
     */
    const textLimitHint = (type, limit = 500) => {
          if (!type || typeof type !== 'string')
            return `0/${limit}`;

          return `${type.length}/${limit}`
        }


    const handlerAdd = async () => {

      let hasError = false;
      let formData = new FormData();
      for (let fieldIndex in fields.value) {
        if (typeof fields.value[fieldIndex] == "object") {
          let r = validateFormItem(fields.value[fieldIndex]);
          if (r.valid) {
            for (let vIndex in r.value) {
              if (typeof r.value[vIndex] == "object") {
                formData.append(r.value[vIndex].name, r.value[vIndex].value);
              }
            }
          } else {
            fields.value[fieldIndex].error = true;
            hasError = true;
          }
        }
      }
      if (!hasError) {
        progress.show();
        for (let dataIndex in subResponseApplication.value.action.data) {
          formData.append(dataIndex, subResponseApplication.value.action.data[dataIndex]);
        }
        await send(subResponseApplication.value.action.link, {method: "POST"}, formData).then((response) => {
          if(response.error) {
            showNotification("danger",'',response.error);

          } else {
            showNotification(
                'nativeSuccess',
                response.title,
                response.success,
                {
                  actions:[
                    {
                      bg:'#00A59E',
                      color:'',
                      title:response.okBtn,
                      action:false,
                      paternAction:'reload'
                    }
                  ]
                }
            );
          }
          progress.hide();
        })
      }

    }

    return {
      closeModal,
      textLimitHint,
      subResponseApplication,
      fields,
      handlerAdd,
      applicationText,
    }
  }
}
</script>

<style lang="scss" scoped>
.respond-application {
  min-height: 100vh;
  background-color: #fff;
}
.respond-application-background{
  position: absolute;
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
}
.respond-application-modal{
  position: absolute;
  max-width: 684px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #FFFFFF;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 45px 64px 60px 57px;
  width: 100%;
  max-height: 100vh;
  overflow-y: auto;
  @include mobile{
    padding: 20px;
  }
  &__title{
    margin: 0 0 36px;
  }
  &__text{
    font-size: 14px;
    line-height: 20px;
    color: #161515;
    margin-bottom: 12px;
  }
  &__subText{
    font-size: 12px;
    line-height: 16px;
    color: #68737D;
    margin-bottom: 29px;
  }
  :deep{
    .label{
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #68737D;
    }
    .field.filled .label, .field.focus .label {
      transform: translate3d(0, -0.5rem, 0) scale(0.9);
      font-size: 12px;
    }
    .field{
      margin-bottom: 29px;
    }
    .respond-application-file{
      margin: 0 0 3px;
    }
  }
}
.respond-application-reset{
  border: 1px solid #00A59E;
}
.respond-application-add{
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #68737D;
  margin-bottom: 35px;
  cursor: pointer;
  &__icon{
    margin-right: 11px;
  }
}
.respond-application-buttons{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 23px;
  @include mobile{
    grid-template-columns: 1fr;
  }
}
.respond-application-files{
  display: grid;
  grid-row-gap: 5px;
  margin-bottom: 15px;
}
</style>